import script from "./list-storie.vue?vue&type=script&setup=true&lang=js"
export * from "./list-storie.vue?vue&type=script&setup=true&lang=js"

import "./list-storie.vue?vue&type=style&index=0&id=24595bc0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24595bc0"]])

export default __exports__